import { apiGet, apiLogin, apiPost } from 'api';

const user = {
    login: async (email: string, password: string) => {
        // console.log("Email: ", email);
        // console.log("Password: ", password);

        var body = {
            Username : email,
            Password : password
        }
        const data = await apiLogin(`${process.env.REACT_APP_AUTH_API_URI}/api/user/authenticate`, body);
        // console.log("Data: ", data);
        return data;
    },
    validate: async () => {
        const data = await apiPost(`${process.env.REACT_APP_AUTH_API_URI}/api/user/validate`);
        return data;
    }
}

export default user;
